
import { StoreApi } from 'zustand';
import { PriceState } from '../../types';
import { UserState } from '../../../auth/userSlice';
import { priceAlertService } from '@/services/priceAlerts/priceAlertService';
import { debugError } from '@/utils/debugLogger';

type GetPriceState = () => PriceState & UserState;
type SetPriceState = StoreApi<PriceState & UserState>["setState"];

export const loadUserPriceAlerts = async (
  set: SetPriceState,
  get: GetPriceState,
  userId: string
) => {
  try {
    const alerts = await priceAlertService.loadUserAlerts(userId);
    
    set((state: PriceState & UserState) => ({
      priceAlerts: [...state.priceAlerts.filter(alert => !alert.userId), ...alerts]
    }));
  } catch (error) {
    debugError('pricing', '[loadUserPriceAlerts] Error loading user alerts:', error);
  }
};
